webpackJsonp([40297266890740],{

/***/ 1666:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"BillingGroupEdge","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"cursor","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"node","type":{"kind":"OBJECT","name":"BillingGroup","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-billing-group-edge-c170451a1581f103e05a.js